import styled from '@emotion/styled/macro'

export const ActivityContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const ActivityUL = styled.ul`
  padding: 0;
  width: 100%;
`
